import axiosInstance from '../../../axiosInstance2';
import apiEndpoints from '../../../api';

export const getWebmasterDashboardReq = (action) => {
    const params = {
        loginFrequency: action?.data?.loginFrequency || 'monthly',
        userTypeFrequency: action?.data?.userTypeFrequency || 'monthly',
        recentLimit: action?.data?.recentLimit ?? 10,
    };
    return axiosInstance.get(apiEndpoints.GET_WEBMASTER_DASHBOARD_API, { params })
        .then((response) => response)
        .catch((errors) => errors);
};

// GET /api/complaints/all — super-admin, cross-society complaint list.
// The backend rejects unknown or empty query keys with a 400, so only the
// whitelisted filters that actually hold a value are sent.
const ALL_COMPLAINTS_PARAMS = [
    'society_id', 'page', 'limit', 'status', 'priority', 'search',
    'from_date', 'to_date', 'category_id', 'flat_id', 'wing_id',
    'assigned_to_user_id', 'raised_by_user_id',
];

export const getCtrlAllComplaintsReq = (action) => {
    const data = action?.data || {};
    const params = {};
    ALL_COMPLAINTS_PARAMS.forEach((key) => {
        const value = data[key];
        if (value != null && value !== '') params[key] = value;
    });
    // Hand back the server's error body so its `message` reaches the UI
    // (403 "Super administrator access required", 400 validation text).
    return axiosInstance.get(apiEndpoints.CTRL_ALL_COMPLAINTS_API, { params })
        .then((response) => response)
        .catch((errors) => errors?.response?.data || errors);
};
